import Widget from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';
import app from 'flarum/common/app';
import Button from 'flarum/common/components/Button';
import ForumCarouselEditModal from '../../forum/components/ForumCarouselEditModal';

export default class CarouselWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.currentIndex = this.attrs.state?.currentIndex || 0;
    this.autoplayTimer = this.attrs.state?.autoplayTimer || null;
    this.items = [];
    this.settings = {};
    this.loadItems();
    this.loadSettings();
  }

  loadSettings() {
    // 从 API 序列化的 settings 中获取
    const apiSettings = app.forum.attribute('custom-carousel-widget.settings');
    
    if (apiSettings) {
      this.settings = {
        autoplay: apiSettings.autoplay !== false,
        autoplayInterval: apiSettings.autoplayInterval || 5000,
        showIndicators: apiSettings.showIndicators !== false,
        showArrows: apiSettings.showArrows !== false,
        height: apiSettings.height || '400px',
        transitionDuration: apiSettings.transitionDuration || 500,
      };
    } else {
      // 备用：从单个设置中读取
      this.settings = {
        autoplay: app.forum.attribute('custom-carousel-widget.autoplay') === '1' || 
                  app.forum.attribute('custom-carousel-widget.autoplay') === 'true' ||
                  app.forum.attribute('custom-carousel-widget.autoplay') === true,
        autoplayInterval: parseInt(app.forum.attribute('custom-carousel-widget.autoplay_interval')) || 5000,
        showIndicators: app.forum.attribute('custom-carousel-widget.show_indicators') === '1' || 
                        app.forum.attribute('custom-carousel-widget.show_indicators') === 'true' ||
                        app.forum.attribute('custom-carousel-widget.show_indicators') === true,
        showArrows: app.forum.attribute('custom-carousel-widget.show_arrows') === '1' || 
                    app.forum.attribute('custom-carousel-widget.show_arrows') === 'true' ||
                    app.forum.attribute('custom-carousel-widget.show_arrows') === true,
        height: app.forum.attribute('custom-carousel-widget.height') || '400px',
        transitionDuration: parseInt(app.forum.attribute('custom-carousel-widget.transition_duration')) || 500,
      };
    }
  }

  loadItems() {
    // 尝试从 API 返回的 items 中加载
    const apiItems = app.forum.attribute('custom-carousel-widget.items');
    
    if (apiItems && Array.isArray(apiItems) && apiItems.length > 0) {
      // 从 API 返回的数据中加载
      this.items = apiItems;
      return;
    }
    
    // 备用：从单个设置中加载
    const itemCount = parseInt(app.forum.attribute('custom-carousel-widget.item_count')) || 3;
    this.items = [];
    
    for (let i = 1; i <= itemCount; i++) {
      const title = app.forum.attribute(`custom-carousel-widget.item_${i}_title`);
      const description = app.forum.attribute(`custom-carousel-widget.item_${i}_description`);
      const imageUrl = app.forum.attribute(`custom-carousel-widget.item_${i}_image`);
      const linkUrl = app.forum.attribute(`custom-carousel-widget.item_${i}_link`);
      
      // 只要有图片URL就添加项目，title 和 description 可以为空
      if (imageUrl) {
        this.items.push({
          title: title || '',
          description: description || '',
          imageUrl: imageUrl || '',
          linkUrl: linkUrl || '',
        });
      }
    }
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    this.startAutoplay();
  }

  onremove(vnode) {
    super.onremove(vnode);
    this.stopAutoplay();
  }

  className() {
    return 'CustomCarouselWidget';
  }

  icon() {
    // Widget icon.
    return 'fa-light fa-images';
  }

  title() {
    return app.translator.trans('tf-carousel-widget.forum.title');
  }

  description() {
    return app.translator.trans('tf-carousel-widget.forum.description');
  }

  icon() {
    return 'fa-light fa-images';
  }

  className() {
    return 'CustomCarouselWidget';
  }

  header() {
    return null;
  }

  content() {
    // 确保 items 和 settings 已初始化
    if (!this.items || !this.settings) {
      return null;
    }

    if (this.items.length === 0) {
      return null;
    }

    const carouselStyle = {
      height: this.settings.height || '26.25rem',
      '--transition-duration': `${this.settings.transitionDuration || 500}ms`,
    };

    const canEdit = app.forum.attribute('custom-carousel-widget.canEditCarousel');

    return (
      <div className="custom-carousel-widget" style={carouselStyle}>
        {canEdit && (
          <div className="carousel-widget-edit-bar">
            <Button
              className="Button Button--primary Button--small"
              icon="fa-light fa-pen"
              onclick={() => app.modal.show(ForumCarouselEditModal)}
            >
              {app.translator.trans('tf-carousel-widget.forum.edit_carousel')}
            </Button>
          </div>
        )}
        <div className="carousel-container">
          <div 
            className="carousel-inner"
            onmouseenter={() => this.onMouseEnter()}
            onmouseleave={() => this.onMouseLeave()}
            style={{
              transform: `translateX(-${this.currentIndex * 100}%)`,
              transition: `transform ${this.settings.transitionDuration}ms ease-in-out`,
            }}
          >
            {this.items.map((item, index) => (
              <div 
                key={index} 
                className="carousel-item"
                onclick={() => item.linkUrl && (window.location.href = item.linkUrl)}
                style={{ 
                  cursor: item.linkUrl ? 'pointer' : 'default',
                  backgroundImage: `url(${item.imageUrl})`,
                }}
              >
                {(item.title || item.description) && (
                  <div className="carousel-content-wrapper">
                    <div className="carousel-content">
                      {item.title && (
                        <h3 className="carousel-title">{item.title}</h3>
                      )}
                      {item.description && (
                        <p className="carousel-description">{item.description}</p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          {this.settings.showArrows && this.items.length > 1 && (
            <>
              <button 
                className="carousel-arrow carousel-arrow-prev"
                onclick={() => this.prevSlide()}
                aria-label={app.translator.trans('tf-carousel-widget.forum.previous_slide')}
              >
                <i className="fa-light fa-chevron-left"></i>
              </button>
              <button 
                className="carousel-arrow carousel-arrow-next"
                onclick={() => this.nextSlide()}
                aria-label={app.translator.trans('tf-carousel-widget.forum.next_slide')}
              >
                <i className="fa-light fa-chevron-right"></i>
              </button>
            </>
          )}
          
          {this.settings.showIndicators && this.items.length > 1 && (
            <div className="carousel-indicators">
              {this.items.map((_, index) => (
                <button
                  key={index}
                  className={`carousel-indicator ${index === this.currentIndex ? 'active' : ''}`}
                  onclick={() => this.goToSlide(index)}
                  aria-label={app.translator.trans('tf-carousel-widget.forum.go_to_slide', {number: index + 1})}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  startAutoplay() {
    if (this.settings.autoplay && this.items.length > 1) {
      this.autoplayTimer = setInterval(() => {
        this.nextSlide();
      }, this.settings.autoplayInterval || 5000);
    }
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    m.redraw();
  }

  prevSlide() {
    this.currentIndex = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
    m.redraw();
  }

  goToSlide(index) {
    this.currentIndex = index;
    m.redraw();
  }

  onMouseEnter() {
    this.stopAutoplay();
  }

  onMouseLeave() {
    this.startAutoplay();
  }
}
